import { EMAIL_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validateEmail = (email: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = EMAIL_VALIDATOR.test(String(email));
  if (!isValid) {
    result.error = 'Invalid Email address';
    result.isValid = false;
  }

  return result;
};
